import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { addReminderAction } from 'redux/slices/iCalendarV4/reminderSlice';
import { closeNestedDialogAction } from 'redux/slices/nestedDialogSlice';
import ICalendarReminderForm from './ICalendarReminderForm';

const ICalendarReminderCreate = () => {
    const dispatch = useDispatch();

    const { t } = useTranslation();

    const reminder = {
        time: 1,
        unit: 'h',
        direction: 'before',
        deliveryMethod: 'async_message',
        enabled: true,
        targetActorType: 'all',
    };

    const handleSubmit = ({ reminderDto, onSuccess, onFailure }) => {
        dispatch(
            addReminderAction({
                dataDto: reminderDto,
                onSuccess: () => {
                    onSuccess();
                    dispatch(closeNestedDialogAction());
                },
                onFailure: onFailure,
            }),
        );
    };

    return <ICalendarReminderForm action={t('iCalendar.reminder.new')} reminder={reminder} onSubmit={handleSubmit} />;
};

export default ICalendarReminderCreate;
